export default __webpack_public_path__ + "static/media/Q18_0_resized.610259bb.jpg";